// BETA-ONLY: Remove this feature when beta ends

interface QuestionSectionProps {
  number: number;
  title: string;
  subtitle?: string;
  isActive: boolean;
  children: React.ReactNode;
}

export function QuestionSection({
  number,
  title,
  subtitle,
  isActive,
  children,
}: QuestionSectionProps): JSX.Element {
  return (
    <section className="mb-8">
      <h2 className="text-sm font-semibold text-ink mb-1 flex items-center gap-2">
        <span
          className={`w-6 h-6 rounded-full inline-flex items-center justify-center text-xs font-bold ${
            isActive ? 'bg-evergreen text-white' : 'bg-soft-neutral text-muted'
          }`}
        >
          {number}
        </span>
        {title}
      </h2>
      {subtitle && (
        <p className="text-sm text-muted ml-8 mb-3">{subtitle}</p>
      )}
      {!subtitle && <div className="mb-3" />}
      {children}
    </section>
  );
}
